import { TabBookingAbstract } from './tabBookingAbstract'
import StrUtils from '@/utils/StrUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { SpecialGoods } from '@/class/model/booking/SpecialGoods'
import { sortByMultiField } from '@/utils'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { getIMDGCodeByUNNo } from '@/api/sysManage/imdgCode'
import {
  getContainerUsages,
  relatedContainerUsages,
  unRelatedContainerUsages
} from '@/api/seaExport/specialGoods'
import { synchronizationSendMessage } from '@/api/seaExport/containerUsage'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'

export class TabSpecialGoodsBase extends TabBookingAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.$message = this.view.$message
    this.$confirm = this.view.$confirm
    this.$refs = this.view.$refs
    this.$store = this.view.$store
    this.$i18n = this.view.$i18n
    this.$emit = this.view.$emit
    this.$t = this.view.$t
    this.$checkPermission = this.view.$checkPermission
  }

  get job() {
    return this.view.job
  }

  set job(job) {
    this.view.job = job
  }
  get currentState() {
    return this.view.currentState
  }

  set currentState(currentState) {
    this.view.currentState = currentState
  }

  async dataChanged() {
    if (!this.job) return
    this.changeCurrentState()
    const jobClass = new SeaExportJob(this.job)

    await jobClass.getSpecialGoods()
    this.view.specialGoods = this.job.specialGoods

    this.loadSuccess()
  }

  loadSuccess() {
    this.loadColSoNo()

    if (this.view.specialGoods && this.view.specialGoods.length > 0) {
      this.view.editObj = this.view.specialGoods[0]
      if (this.job.cargoType === 'DG') {
        this.sortByOrder(this.view.specialGoods)
        // 目前没有危险品编号，需要生成
        if (this.view.editObj && StrUtils.isEmpty(this.view.editObj.danNo)) {
          this.view.editObj.danNo = JobUtils.createDanNo(this.job)
        }

        this.view.$nextTick(async() => {
          const event = this.setRowSelect(this.view.editObj)
          this.goodsItemClickHandler(event)
        })
      }
    } else {
      if (this.currentState === 'DG') {
        // _editObj置空，清空表单
        this.view.editObj = new SpecialGoods().fillDefaultValue().getData()
        this.view.specialGoods = []
        this.view.containerUsages = []
        this.clearSpecialGoodsView()
      }
      // _editObj此时必是空，如果是除危险品之外，其他的特殊物品，则默认新建一个【h5这边 this.view.editObj 是一个对象不会为null】
      if (this.currentState !== 'DG' && (this.view.editObj === null || !this.view.editObj.jobUuid)) {
        this.view.editObj = new SpecialGoods().fillDefaultValue().getData()
        this.view.editObj.jobUuid = this.job.uuid
      }
    }
    if (!this.view.editObj.flashPointUnit) {
      this.view.editObj.flashPointUnit = SeaExportConstants.TEMP_UNIT_CEL.code
    }

    this.initPushDataChange()
  }
  loadColSoNo() {
    this.view.colSoNo = []
    const soNoArray = this.job.soNo.split('\n')
    for (const str of soNoArray) {
      this.view.colSoNo.push({ 'sonos': str })
    }
  }
  /**
   * 按照指定字段排序
   * @param categoryArray
   * @return
   */
  sortByOrder(categoryArray) {
    if (categoryArray === null || categoryArray.length === 0) {
      return null
    } else {
      sortByMultiField(categoryArray, ['danNo'], false)
    }
  }

  // 设置 选中行(加载数据后默认选中第一行记录)
  setGridSelect(selectLastRow = false) {
    const nodes = this.view.danger.gridOptions.api.getRenderedNodes()

    // 选中最后一行记录(用于 行 新增，删除)
    if (selectLastRow) {
      let index = 0
      for (const item of nodes) {
        if (index === nodes.length - 1) {
          item.setSelected(true)
          this.view.editObj = item.data
        }
        index++
      }
    } else {
      // 默认选中第一个
      for (const item of nodes) {
        item.setSelected(true)
        this.view.editObj = item.data
        break
      }
    }
  }

  // 设置 选中行(加载数据后默认选中第一行记录)
  setRowSelect(data) {
    const nodes = this.view.danger.gridOptions.api.getModel().rowsToDisplay
    const item = nodes.find(node => node.data.danNo === data.danNo)
    item.setSelected(true)
    return { data: item.data }
  }

  goodsItemClickHandler(event = null) {
    if (event) {
      this.view.editObj = event.data
    }

    const selItem = this.view.editObj
    let editObj = this.view.editObj
    // 切换前先将表单值填充到当前的_editObj
    if (this.view.isEditing) {
      this.updateModelFromViewDetail(editObj)
    }

    if (selItem !== editObj) {
      editObj = selItem
      if (editObj === null || !editObj.jobUuid) {
        // 危险品被全部删除，因HSCode不在_editObj中，要把页面的hscode清空掉
        editObj.hsCode = ''
      }
    }

    // 获取 ContainerUsages
    this.view.containerUsages = []
    if (editObj && !StrUtils.isEmpty(editObj.uuid)) {
      this.view.containerUsages = this.view.editObj.containerUsageVOS
    }

    this.view.enablePrint = (!this.view.isEditing && selItem !== null)
  }
  clearSpecialGoodsView() {

  }
  initPushDataChange() {

  }
  loadUsageResultHandler(data) {
    if (this.view.editObj) {
      if (StrUtils.isEmpty(data)) {
        this.view.containerUsages = []
      } else {
        this.view.containerUsages = data
        this.view.editObj.containerUsageVOS = data
      }
    }
  }
  updateModelFromViewDetail(model) {

  }
  changeCurrentState() {
    if (this.view.job) {
      const cargoType = this.view.job.cargoType
      if (cargoType) {
        this.view.currentState = cargoType
      }
    }
  }

  // 危险品-新增
  addSpGoods() {
    const job = this.job
    if (StrUtils.isEmpty(this.job.uuid)) {
      this.$message.warning(this.$t('Message.FirstSaveTheBusinessAddSpecialGoods'))
      return
    }
    const specialGoods = new SpecialGoods().fillDefaultValue().getData()
    this.view.specialGoods.push(specialGoods)
    job.specialGoods = this.view.specialGoods
    specialGoods.jobUuid = job.uuid
    specialGoods.hsCode = job.hsCode
    specialGoods.flashPointUnit = SeaExportConstants.TEMP_UNIT_CEL.code
    specialGoods.danNo = JobUtils.createDanNo(job)
    this.view.editObj = specialGoods

    this.view.$nextTick(async() => {
      this.setGridSelect(true)
      this.goodsItemClickHandler()
    })

    this.view.editLog = true
  }

  // 危险品-删除
  delSpGoods() {
    const selSpGoods = this.view.danger.gridApi.getSelectedRows()
    if (selSpGoods === null || selSpGoods.length === 0) {
      this.$message.info(this.$t('Message.PleaseSelectData'))
      return
    }

    for (const spg of selSpGoods) {
      // spg.containerUsages = null 后端保存移除 关联装箱信息
      const index = this.view.specialGoods.findIndex(p => p.danNo === spg.danNo)
      if (!StrUtils.isEmpty(spg.uuid)) {
        this.view.delSpecialGoodsUuids.push(spg.uuid)
      }
      this.view.specialGoods.splice(index, 1)
    }
    this.view.editLog = true
    if (this.view.specialGoods && this.view.specialGoods.length > 0) {
      this.view.$nextTick(async() => {
        await this.setGridSelect()
      })
    } else {
      this.view.editObj = {}
    }

    this.goodsItemClickHandler()
  }

  // 危险品-导入-结果处理
  importResultHandler(result) {
    if (result) {
      const code = result.code
      const msg = result.msg
      if (code === '0') {
        const selItem = this.view.editObj
        selItem.secondarySpecialGoods = result.goods['secondarySpecialGoods']
        selItem.danUNNo = result.goods['danUNNo']
        selItem.grossWeight = result.goods['grossWeight']
        selItem.neatWeight = result.goods['neatWeight']
        selItem.outerPackagingType = result.goods['outerPackagingType']
        selItem.chineseCommodity = result.goods['chineseCommodity']
        selItem.englishCommodity = result.goods['englishCommodity']
      } else {
        this.$message.error(msg + this.$t('Message.Error'))
      }
    }
  }

  // 危险品-关联
  fillInSpGoods() {
    const selItem = this.view.danger.gridApi.getSelectedRows()
    if (selItem === null || selItem.length === 0) {
      this.$message.warning(this.$t('Message.PleaseSelectData'))
      return
    }
    if (StrUtils.isEmpty(this.view.editObj.danUNNo)) {
      this.$message.warning(this.$t('Message.UNNoIsEmpty'))
      return
    }
    this.view.editLog = true
    getIMDGCodeByUNNo({ unNo: this.view.editObj.danUNNo }).then(res => { this.getHsCodeHandler(res.data) })
  }

  getHsCodeHandler(data) {
    const imdgCodes = data
    // const selItem = this.view.danger.gridApi.getSelectedRows()
    // 如果只能查到一个imdgcode则直接填充，多个则通过窗口选择
    if (imdgCodes && imdgCodes.length > 0) {
      if (imdgCodes.length === 1) {
        const imdgCode = imdgCodes[0]
        this.fillInFromImdgCode(this.view.editObj, imdgCode)
      } else {
        this.view.imdgCodeSelDialog.imdgCodes = imdgCodes
        this.view.imdgCodeSelDialog.visible = true
      }
    } else {
      this.$message.warning(this.$t('Message.NoAssociatedInfo'))
    }
  }

  onImdgCodeSelSucceed(imdgCode) {
    if (imdgCode) {
      this.fillInFromImdgCode(this.view.editObj, imdgCode)
    }
  }

  /**
   * 将imdgCode里的一些值填充到specialGoods中
   */
  fillInFromImdgCode(specialGoods, imdgCode) {
    specialGoods.danClassNo = imdgCode.classification
    specialGoods.danPacking = imdgCode.packingGroup
    specialGoods.danEMS = imdgCode.emergencySchedule
    specialGoods.danPoint = imdgCode.flashpoint
    specialGoods.correctTransportName = imdgCode.psn

    let subsidiaryRisks = imdgCode.subsidiaryRisks
    const isEight = !StrUtils.isEmpty(subsidiaryRisks) && (subsidiaryRisks === '3+8' || subsidiaryRisks === '3(8)' || subsidiaryRisks === '3/8')
    if (isEight) {
      subsidiaryRisks = '8'
    }
    specialGoods.secondarySpecialGoods = subsidiaryRisks
  }

  linkUsageClickHandler() {
    if (!this.view.editObj || !this.view.editObj.uuid) {
      this.$message.warning(this.$t('Message.PleaseAddSpecialGoodsFirst'))
      return
    }
    this.view.containerUsageDialog.visible = true
  }
  /**
   * button click 关联装箱信息
   */
  linkUsagesEventHandler(data) {
    const isExist = this.view.containerUsages.some(p => {
      if (data.includes(p.containerUsageUuid)) {
        this.$message.warning(this.$t('Message.PackingAddNotRepeat'))
        return true // 提前退出循环
      }
      return false
    })
    if (isExist) {
      return
    }
    relatedContainerUsages({ specialGoodsUuid: this.view.editObj.uuid, usageIds: data }).then(() => { this.saveRelatedResulthandler() })
  }

  saveRelatedResulthandler(message) {
    const editObj = this.view.editObj
    const job = this.job

    // 获取 ContainerUsages
    this.view.containerUsages = []
    if (editObj && !StrUtils.isEmpty(editObj.uuid)) {
      getContainerUsages({ specialGoodsUuid: editObj.uuid }).then(res => { this.loadUsageResultHandler(res.data) })
    }

    if ((StrUtils.isEmpty(job.relatedJob) && !StrUtils.isEmpty(job.trustFromJob)) ||
      StrUtils.isEmpty(job.trustFromJob) && !StrUtils.isEmpty(job.relatedJob)) {
      synchronizationSendMessage(job.uuid, 1, this.$store.getters.tenantId, s.currentOffice.chineseName)
    }
    if (message) {
      this.$message.success(message)
    } else {
      this.$message.success(this.$t('Message.OperationSuccessfully'))
    }
  }

  /**
   * button click 移除关联
   */
  delLinkUsageClickHandler() {
    const selRelatedUsage = this.view.box.gridApi.getSelectedRows()
    if (selRelatedUsage === null || selRelatedUsage.length === 0) {
      this.$message.warning(this.$t('Message.PleaseSelectData'))
      return
    }
    this.$confirm(this.$t('Message.SureYouRemoveThisNData1') + ' ' + selRelatedUsage.length + ' ' + this.$t('Message.SureYouRemoveThisNData2'), this.$t('common.tips.prompt'), {
      confirmButtonText: this.$t('common.btn.ok'),
      cancelButtonText: this.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      this.view.editLog = true
      // var relatedUsage = this.view.containerUsages
      const usageIds = []
      for (const usage of selRelatedUsage) {
        usageIds.push(usage.uuid)
      }
      unRelatedContainerUsages({ specialGoodsUuid: this.view.editObj.uuid, usageIds: usageIds }).then(() => { this.saveRelatedResulthandler() })
      this.view.refreshCache()
    })
  }
}
